import Cookies from "js-cookie";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import filterRoutesByAccess from "../../Utils/filterRoutesByAccess";
import axiosInstance from "../../config/axiosInstance";
import { useAppSetting } from "../../context/appSettingContext";
import { useAuth } from "../../context/userContext";
import useAlert from "../../hooks/Alert";
import CustomInputField from "../InputFeilds/CustomInputField";
import Alert from "./Alert/Alert";

function Login({ baseURL, clientID, appSettings }) {
    const navigate = useNavigate();
    const { setAuthUser } = useAuth();
    const { showAlert, setShowAlert, alertStyle, setAlertStyle, alertMessage, setAlertMessage, hideAlert } = useAlert();
    const { clientAccess } = useAppSetting();
    const { Mobile_length } = appSettings || {};
    const mobilePrefix = appSettings?.SMS_SETTINGS?.ALLOWED_PREFIX || "";
    // State to toggle between email and mobile login
    const [useMobile, setUseMobile] = useState(true); // Default is mobile
    const [loginValue, setLoginValue] = useState(""); // State to hold input value
    const [password, setPassword] = useState(""); // State to hold password value
    const [errors, setErrors] = useState({});
    const [loadingLogin, setLoadingLogin] = useState(false);
    const { filteredRoutes } = filterRoutesByAccess(clientAccess);

    const validateForm = () => {
        const newErrors = {};

        if (!loginValue) {
            newErrors.email = "Email is required";
            newErrors.mobile = "Mobile is required";
        }

        if (!useMobile && loginValue && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loginValue)) {
            newErrors.email = "Invalid Email Address";
        }

        if (useMobile && !loginValue) {
            newErrors.mobile = "Phone number is required.";
        } else if (useMobile && loginValue.length != Number(Mobile_length) && Mobile_length>0 && Mobile_length!=="") {
            const enteredLen = loginValue.length;
            const expectedLen = Number(Mobile_length);

            newErrors.mobile =
                enteredLen < expectedLen
                    ? `Phone number is too short. Please enter ${expectedLen} digits (Example: ${mobilePrefix}${"X".repeat(
                          expectedLen
                      )})`
                    : `Phone number is too long. Please enter only ${expectedLen} digits (Example: ${mobilePrefix}${"X".repeat(
                          expectedLen
                      )})`;
        }

        if (!password) {
            newErrors.password = "Password is required";
        } else if (password.length < 3) {
            newErrors.password = "Password must be at least 4 characters long";
        }

        setErrors(newErrors);

        // Clear errors after 3 seconds
        if (Object.keys(newErrors).length > 0) {
            setTimeout(() => {
                setErrors({});
            }, 5000);
        }

        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    async function sendLogin(event, baseURL, closure) {
        event.preventDefault();

        if (!validateForm()) return;

        setLoadingLogin(true);

        const formData = new FormData(event.target.form);
        const loginData = useMobile ? formData.get("mobile") : formData.get("email");
        const payLoad = {
            DIV_DES: "",
            DIV_ID: "1",
            FUNCTION: "LoyLogin",
            SEND_KEY: "123456",
            DATA: {
                AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                // USERNAME: useMobile ? mobilePrefix + loginData : loginData, // commented for prefix inclusion from input
                USERNAME: useMobile ? loginData : loginData, // Send either mobile or email
                PWORD: formData.get("password"),
                TYPE_NAME: useMobile ? "PHONE" : "EMAIL",
                LOC_ID: "001",
                CLIENT_ID: clientID,
            },
        };

        if (event.target.form.checkValidity()) {
            try {
                // Send the login request using axios
                const response = await axiosInstance.post(`${baseURL}/LoyLogin`, payLoad, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                if (response?.data?.STATUS) {
                    // Successful login
                    setAlertStyle({
                        background: "linear-gradient(to right, #4caf50 0%, #2e7d32 100%)",
                    });
                    setAlertMessage({
                        success: true,
                        message: "Successfully logged in",
                        mode: "Login",
                    });
                    setShowAlert("d-block");

                    Cookies.set("wafaa-user-data", JSON.stringify(response.data), { expires: 3650 });

                    setAuthUser(response.data);

                    setTimeout(() => {
                        setLoadingLogin(false);
                        closure(`${filteredRoutes[0]}`);
                    }, 1500);
                } else {
                    // Handle login failure
                    setAlertStyle({
                        background: "linear-gradient(to right, #f6743e 0%, #d42525 100%)",
                    });
                    setAlertMessage({
                        success: false,
                        message: response?.data?.MESSAGE || "Login failed",
                        mode: "Login",
                    });
                    setShowAlert("d-block");
                    setLoadingLogin(false);
                }
            } catch (error) {
                // Handle any errors during login
                console.error("Error during login:", error.message);
                setAlertStyle({
                    background: "linear-gradient(to right, #f6743e 0%, #d42525 100%)",
                });
                setAlertMessage({
                    success: false,
                    message: "Failed to login. Please try again later.",
                    mode: "Login",
                });
                setShowAlert("d-block");
                setLoadingLogin(false);
            }
        } else {
            // Handle invalid form inputs
            setAlertStyle({
                background: "linear-gradient(to right, #f6743e 0%, #d42525 100%)",
            });
            setAlertMessage({
                success: false,
                message: "Failed to login. Inputs not valid",
                mode: "Login",
            });
            setShowAlert("d-block");
            setLoadingLogin(false);
        }
    }

    // Function to handle toggling between mobile and email
    function toggleLoginMethod(isMobile) {
        setUseMobile(isMobile);
        setLoginValue(""); // Clear the input field value when toggling
    }

    return (
        <div
            className="overflow-hidden"
            style={{ background: "rgba(247, 246, 251, 1)", height: "calc(100dvh - 110px)" }}
        >
            {/* <Title name="LOGIN" /> */}
            <Alert showAlert={showAlert} alertStyle={alertStyle} alertMessage={alertMessage} hideAlert={hideAlert} />
            <div style={{ overflowY: "auto", height: "100%" }}>
                <form className="" autoComplete="off">
                    <div className=" w-90 mx-auto ">
                        <div className="mt-3 font-size-12">
                            {/* Toggle Button */}

                            <div className="text-center my-4 d-flex justify-content-center">
                                <style>
                                    {`
                                        .toggle-btn-container {
                                            position: relative;
                                            display: flex;
                                            border-radius: 6px;
                                            overflow: hidden;
                                            width: fit-content;
                                            box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
                                            background-color: #f0f0f0;
                                        }
                                        .toggle-btn-container::before {
                                            content: '';
                                            position: absolute;
                                            top: 0;
                                            left: 0;
                                            width: 50%;
                                            height: 100%;
                                            background-color: white;
                                            border-radius: 6px;
                                            z-index: 0;
                                            transition: transform 0.2s ease-in-out;
                                            transform: translateX(${useMobile ? "100%" : "0%"});
                                        }
                                        .toggle-btn {
                                            position: relative;
                                            padding: 8px 40px;
                                            font-size: 12px;
                                            font-weight: bold;
                                            border: none;
                                            outline: none;
                                            cursor: pointer;
                                            background: none;
                                            z-index: 1;
                                            color: #555;
                                            transition: color 0.3s ease;
                                        }
                                        .toggle-btn-active {
                                            color: black;
                                        }
                                        `}
                                </style>

                                <div className="toggle-btn-container">
                                    <button
                                        type="button"
                                        className={`toggle-btn ${!useMobile ? "toggle-btn-active" : ""}`}
                                        onClick={() => toggleLoginMethod(false)}
                                    >
                                        Email
                                    </button>
                                    <button
                                        type="button"
                                        className={`toggle-btn ${useMobile ? "toggle-btn-active" : ""}`}
                                        onClick={() => toggleLoginMethod(true)}
                                    >
                                        Mobile
                                    </button>
                                </div>
                            </div>

                            <div className="d-flex flex-column gap-3">
                                {/* Conditionally render Mobile or Email field */}
                                {useMobile ? (
                                    <CustomInputField
                                        defaultPrefix={mobilePrefix}
                                        key="mobile"
                                        label="Mobile"
                                        type="tel"
                                        name="mobile"
                                        value={loginValue}
                                        onChange={(e) => setLoginValue(e.target.value)}
                                        error={!!errors.mobile}
                                        helperText={errors.mobile}
                                        // important={true}
                                        hideLabel={false}
                                    />
                                ) : (
                                    <CustomInputField
                                        key="email"
                                        label="Email"
                                        type="text"
                                        name="email"
                                        value={loginValue}
                                        onChange={(e) => setLoginValue(e.target.value)}
                                        error={!!errors.email}
                                        helperText={errors.email}
                                        // important={true}
                                        hideLabel={false}
                                    />
                                )}

                                {/* Password Field */}
                                <CustomInputField
                                    key="password"
                                    label="Password"
                                    type={"password"}
                                    name="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    error={!!errors.password}
                                    helperText={errors.password}
                                    // important={true}
                                    hideLabel={false}
                                    readOnly={false}
                                />
                            </div>
                            <div className="text-center mt-3">
                                <Link
                                    to="/forgot-password"
                                    className="text-wafaa-purple text-decoration-none my-3 text-center font-size-14 font-weight-600 w-auto"
                                >
                                    Forgot Password ?
                                </Link>
                            </div>
                        </div>
                        {/* 
                            <div className="text-center position-absolute bottom-10  w-85 height-50 pt-2 max-width-700">
                                <button
                                    onClick={async (e) => await sendLogin(e, baseURL, navigate)}
                                    type="button"
                                    className="w-100 btn btn-lg py-2-5 btn-primary bg-wafaa-purple border-wafaa-purple shadow-wafaa-btn font-size-12"
                                >
                                    {loadingLogin ? "Logging in..." : "Login"}
                                </button>
                            </div> */}
                        <div
                            className="max-width-700"
                            style={{
                                position: "fixed",
                                bottom: "0%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "92%",
                            }}
                        >
                            <button
                                disabled={loadingLogin}
                                onClick={async (e) => await sendLogin(e, baseURL, navigate)}
                                className="btn btn-primary bg-wafaa-purple font-size-16"
                                style={{
                                    width: "100%",
                                    height: "45px",
                                    color: "white",
                                    textTransform: "capitalize",
                                    marginBlock: "1rem",
                                    border: "none",
                                    cursor: "pointer",
                                    borderRadius: "4px",
                                    webkittapHighlightColor: "none",
                                }}
                            >
                                {loadingLogin ? "Logging in..." : "Login"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;
